<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-bottom-16">
    <img
      v-if="content.Loyalty.metadata.imageUrl"
      class="cf-image cf-image--logo"
      :alt="merchant.name"
      :src="content.Loyalty.metadata.imageUrl"
      onerror="this.src='/images/image-not-found.png';"
    >

    <template v-if="isLoyaltyCheckinEnabled">
      <h2 class="cf-title cf-title--2">
        {{ content.ScanToCheckInModal.title }}
      </h2>

      <p class="cf-subtitle cf-subtitle--2">
        {{ content.ScanToCheckInModal.description }}
      </p>

      <div
        v-if="isQrCodeEnabled && loyalty.checkinToken"
        class="cf-qr-code-container"
      >
        <vue-qrcode
          class="cf-image cf-image--auto-w cf-image--border"
          :value="loyalty.checkinToken"
          :scale="5"
        />
      </div>

      <div
        v-if="isQrCodeValueEnabled"
        class="cf-flex cf-flex--column cf-flex--align-center cf-flex--justify-center cf-flex--gap-8"
      >
        <p class="cf-subtitle cf-subtitle--2 cf-subtitle--heavy">
          {{ content.ScanToCheckInQrCode.metadata.codeSubtitle }}
        </p>

        <p class="cf-subtitle cf-subtitle--2">
          {{ loyalty.checkinToken }}
        </p>
      </div>
    </template>

    <cf-title-separator v-if="isLoyaltyCheckinEnabled && isLoyaltyReceiptScanningEnabled" />

    <template v-if="isLoyaltyReceiptScanningEnabled">
      <h2 class="cf-title cf-title--2">
        {{ content.ScanToEarnModal.title }}
      </h2>

      <p class="cf-subtitle cf-subtitle--2">
        {{ content.ScanToEarnModal.description }}
      </p>

      <div
        v-if="isBarcodeScanningEnabled"
        role="button"
        tabindex="0"
        class="cf-button cf-button--tertiary cf-button--lg cf-button--fill"
        @click="$openModal('barcodeScanner')"
      >
        <span class="cf-icon far fa-barcode-read" />

        {{ content.ScanToEarnModal.metadata.scanBarcodeCta }}
      </div>

      <div
        v-if="isManualBarcodeEntryEnabled"
        role="button"
        tabindex="0"
        class="cf-button cf-button--tertiary cf-button--lg cf-button--fill"
        @click="handleManualEntryBarcodeClick"
      >
        <span class="cf-icon far fa-keyboard" />

        {{ content.ScanToEarnModal.metadata.manualBarcodeCta }}
      </div>

      <template v-if="!isBarcodeScanningEnabled">
        <cf-title-separator />

        <h3 class="cf-title cf-title--3">
          {{ content.ScanToEarnModal.metadata.appDownloadMessage }}
        </h3>

        <cf-app-download-badges />
      </template>
    </template>

    <p
      class="cf-subtitle cf-subtitle--2 cf-subtitle--heavy cf-cursor-pointer"
      @click="$openModal('learnMore')"
    >
      {{ learnMoreContent }}
    </p>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import CfTitleSeparator from '@/view/components/shared/cf-title-separator/index.vue';

  import CfAppDownloadBadges from '@/view/components/globals/cf-app-download-badges/index.vue';


  export default {
    name: 'ScanToEarn',

    components: {
      CfTitleSeparator,
      CfAppDownloadBadges
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('offers', ['loyalty']),
      ...mapGetters('merchant', ['merchant']),

      isLoyaltyCheckinEnabled() {
        return this.merchant.options.loyaltyOptions.loyaltyCheckInEnabled;
      },

      isLoyaltyReceiptScanningEnabled() {
        return this.merchant.options.loyaltyOptions.loyaltyReceiptScanningEnabled;
      },

      isBarcodeScanningEnabled() {
        return this.merchant.features['retro-barcode-scanning-enabled'];
      },

      isQrCodeEnabled() {
        const { displayMemberCheckinTokenQrCode } = this.merchant.options.loyaltyOptions?.inStoreLoyaltyOptions ?? {};

        return displayMemberCheckinTokenQrCode;
      },

      isQrCodeValueEnabled() {
        const { displayMemberCheckinTokenText } = this.merchant.options.loyaltyOptions?.inStoreLoyaltyOptions ?? {};

        return displayMemberCheckinTokenText;
      },

      isManualBarcodeEntryEnabled() {
        return this.merchant.features['retro-barcode-enter-manually-enabled'];
      },

      learnMoreContent() {
        if (this.isLoyaltyCheckinEnabled && this.isLoyaltyReceiptScanningEnabled) return this.content.ScanToCheckInAndEarnModal.metadata.learnMore;

        if (this.isLoyaltyReceiptScanningEnabled) return this.content.ScanToEarnModal.metadata.learnMore;

        if (this.isLoyaltyCheckinEnabled) return this.content.ScanToCheckInModal.metadata.learnMore;

        return '';
      }
    },

    methods: {
      handleManualEntryBarcodeClick() {
        this.manuallyEnteredBarcode = '';

        this.$openModal('manualBarcodeEntry');
      }
    }
  };
</script>
